module.exports = __webpack_public_path__ + "static/full06-5c47da1670508224d2788c8f0014789d.png";